module.exports = __webpack_public_path__ + "static/media/ss1.7a683350.jpeg";